export default __webpack_public_path__ + "static/media/link-verification-for-mastodon.4dfb65eb.svg";